// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppEnvironmentService } from '../services/app-environment.service';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {

  constructor(private router: Router, private store: Store, private appEnv: AppEnvironmentService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      tap({
        next: (response) => { },
        error: (error: HttpErrorResponse) => {
          if (error.status === 401) {

            window.location.href = this.appEnv.appEnvData.reloadSessionExpired;// could be better for UX to reset the state, but for now for security reasons we just refresh everything to ensure a fresh state
          }
        }
      })
    )
  }
}
